import {Component} from "@angular/core";
import {Page} from "../../orchestration/page";
import {OrderingContext, OrderingContextIntention} from "../../ordering-context/ordering-context";
import {ResponsiveService} from "../../orchestration/responsive.service";
import {NavigationService} from "../../orchestration/navigation.service";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {NavigationParams} from "../../orchestration/navigation-params";
import {StoreData} from "../store-search.model";
import {OrderType} from "../../order/order";

@Component({
    selector: "woa-store-details-page",
    templateUrl: "./store-details-page.component.html",
    providers: [{provide: Page, useExisting: StoreDetailsPageComponent}]
})
export class StoreDetailsPageComponent extends Page {
    OrderType = OrderType;

    orderAheadStoreOption: StoreData;
    orderDeliveryStoreOption: StoreData;
    orderAtTableStoreOption: StoreData;

    public orderingContext: OrderingContext;
    public orderType: OrderType;
    public store: StoreData;

    private webTerminalIds: number[] = [];

    constructor(navigationParams: NavigationParams,
                private orderingContextModel: OrderingContextModel,
                private navigationService: NavigationService,
                public responsiveService: ResponsiveService) {
        super();
        this.orderingContext = navigationParams.get("orderingContext");
        this.orderType = this.orderingContext.selectedOrderType || this.orderingContextModel.orderType;

        if (this.orderingContext.selectedStore) {
            this.store = this.orderingContext.selectedStore;
        } else {
            if (this.orderingContextModel.singleStoreLocation) {
                this.orderAheadStoreOption = this.orderingContextModel.singleStoreLocation.getStoreForOrderType(OrderType.ORDER_AHEAD);
                this.orderDeliveryStoreOption = this.orderingContextModel.singleStoreLocation.getStoreForOrderType(OrderType.ORDER_DELIVERY);
                this.orderAtTableStoreOption = this.orderingContextModel.singleStoreLocation.getStoreForOrderType(OrderType.ORDER_AT_TABLE);
            }
            this.store = this.orderAheadStoreOption || this.orderDeliveryStoreOption || this.orderAtTableStoreOption;

            // Check how many actual different store options we have
            [this.orderAheadStoreOption, this.orderDeliveryStoreOption, this.orderAtTableStoreOption].forEach((storeOption: StoreData) => {
                if (storeOption && this.webTerminalIds.indexOf(storeOption.webTerminalId) == -1) {
                    this.webTerminalIds.push(storeOption.webTerminalId);
                }
            });

            // Default order type if a selection is required and no value is supplied
            if (this.webTerminalIds.length > 1 && !this.orderType) {
                if (this.orderAheadStoreOption) {
                    this.orderType = OrderType.ORDER_AHEAD;
                } else if (this.orderDeliveryStoreOption) {
                    this.orderType = OrderType.ORDER_DELIVERY;
                } else if (this.orderAtTableStoreOption) {
                    this.orderType = OrderType.ORDER_AT_TABLE;
                }
            }
        }
    }

    get intention(): OrderingContextIntention {
        return this.orderingContext.intention == undefined ? OrderingContextIntention.ORDER : this.orderingContext.intention;
    }

    get title(): string {
        return this.orderingContextModel.singleStoreLocation ? "woa.heading.ordering-context.singleStore"
            : this.intention === OrderingContextIntention.VIEW_STORES || this.intention === OrderingContextIntention.SELECT_STORE ? "woa.heading.ordering-context.storeDetails"
                : this.intention !== OrderingContextIntention.VIEW_CURRENT_STORE ? "woa.heading.ordering-context.closestStore"
                    : this.orderingContextModel.isConfirmedDeliveryOrdering ? "woa.heading.ordering-context.currentDeliveryStore"
                        : "woa.heading.ordering-context.currentStore";
    }

    get showStoreOrderTypeOptions(): boolean {
        return this.webTerminalIds.length > 1;
    }

    changeOrderType(orderType: OrderType): void {
        this.orderType = orderType;
        if (orderType === OrderType.ORDER_AHEAD) {
            this.store = this.orderAheadStoreOption;
        } else if (orderType === OrderType.ORDER_DELIVERY) {
            this.store = this.orderDeliveryStoreOption;
        } else {
            this.store = this.orderAtTableStoreOption;
        }
    }

    async orderFromStore(orderType: OrderType): Promise<any> {
        return this.navigationService.dismissPage(this, this.orderingContext
            .withSelectedStore(this.store)
            .withSelectedOrderType(orderType));
    }
}



// WEBPACK FOOTER //
// ./src/app/store/store-details-page/store-details-page.component.ts